(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('pd-marquee-row')) return;

    var RESUME_AFTER = 2500; // ms of no interaction before auto-scroll resumes

    class PdMarqueeRow extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.pd-marquee-row__scroller');
        this.set = this.querySelector('.pd-marquee-row__set');
        this.bar = this.querySelector('.pd-scrubber');
        this.thumb = this.querySelector('.pd-scrubber__thumb');
        if (!this.scroller || !this.set) return;

        this.direction = Number(this.dataset.direction) || 1;
        this.secondsPerItem = Number(this.dataset.secondsPerItem) || 4;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovering = false;
        this.dragging = false;
        this.visible = false;
        this.resumeAt = 0;
        this.last = 0;

        this.measure();
        this.pos = Math.random() * this.W;
        this.apply();

        this.bindEvents();
        new ResizeObserver(() => {
          var ratio = this.W ? this.pos / this.W : 0;
          this.measure();
          this.pos = ratio * this.W;
          this.apply();
        }).observe(this.scroller);
        new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
        }, { threshold: 0.05 }).observe(this);

        requestAnimationFrame((t) => this.tick(t));
      }

      measure() {
        this.W = this.set.getBoundingClientRect().width;
        var items = Math.max(this.set.children.length, 1);
        this.speed = this.W / (items * this.secondsPerItem); // px per second
      }

      wrap(p) {
        if (!this.W) return p;
        p %= this.W;
        return p < 0 ? p + this.W : p;
      }

      apply() {
        this.scroller.scrollLeft = this.pos;
        this.expected = this.scroller.scrollLeft;
        this.paint();
      }

      paint() {
        if (!this.thumb || !this.W) return;
        var viewRatio = Math.min(this.scroller.clientWidth / this.W, 1);
        var thumbPct = Math.max(viewRatio * 100, 8);
        var progress = this.pos / this.W;
        this.thumb.style.width = thumbPct + '%';
        this.thumb.style.left = progress * (100 - thumbPct) + '%';
        this.bar.setAttribute('aria-valuenow', Math.round(progress * 100));
      }

      holdFor(ms) {
        this.resumeAt = Math.max(this.resumeAt, performance.now() + ms);
      }

      bindEvents() {
        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.hovering = true; });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.hovering = false; });
        this.addEventListener('focusin', () => { this.holdFor(Infinity); });
        this.addEventListener('focusout', () => { this.resumeAt = 0; this.holdFor(RESUME_AFTER); });

        this.scroller.addEventListener('touchstart', () => { this.holdFor(Infinity); }, { passive: true });
        this.scroller.addEventListener('touchend', () => { this.resumeAt = 0; this.holdFor(RESUME_AFTER); }, { passive: true });

        // Any scroll we didn't cause (swipe, trackpad, shift+wheel) hands control to the shopper.
        this.scroller.addEventListener('scroll', () => {
          var s = this.scroller.scrollLeft;
          if (Math.abs(s - this.expected) <= 1) return;
          if (this.resumeAt !== Infinity) this.holdFor(RESUME_AFTER);
          if (s < 1) s += this.W;
          else if (s >= this.W) s -= this.W;
          this.pos = s;
          this.apply();
        }, { passive: true });

        if (!this.bar) return;

        this.bar.addEventListener('pointerdown', (e) => {
          e.preventDefault();
          var rect = this.bar.getBoundingClientRect();
          var thumbRect = this.thumb.getBoundingClientRect();
          var travel = Math.max(rect.width - thumbRect.width, 1);
          if (e.target !== this.thumb) {
            // Jump so the thumb centres on the click point.
            var ratio = (e.clientX - rect.left - thumbRect.width / 2) / travel;
            this.pos = this.wrap(Math.min(Math.max(ratio, 0), 0.9999) * this.W);
            this.apply();
          }
          this.dragging = true;
          this.bar.classList.add('is-dragging');
          this.bar.setPointerCapture(e.pointerId);
          var startX = e.clientX;
          var startPos = this.pos;
          var move = (ev) => {
            var next = startPos + (ev.clientX - startX) * (this.W / travel);
            this.pos = Math.min(Math.max(next, 0), this.W - 0.01);
            this.apply();
          };
          var up = () => {
            this.dragging = false;
            this.bar.classList.remove('is-dragging');
            this.bar.removeEventListener('pointermove', move);
            this.bar.removeEventListener('pointerup', up);
            this.bar.removeEventListener('pointercancel', up);
            this.holdFor(RESUME_AFTER);
          };
          this.bar.addEventListener('pointermove', move);
          this.bar.addEventListener('pointerup', up);
          this.bar.addEventListener('pointercancel', up);
        });

        this.bar.addEventListener('keydown', (e) => {
          var card = this.set.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 20 : 200;
          if (e.key === 'ArrowRight') this.pos = this.wrap(this.pos + step);
          else if (e.key === 'ArrowLeft') this.pos = this.wrap(this.pos - step);
          else return;
          e.preventDefault();
          this.apply();
        });
      }

      tick(t) {
        var dt = this.last ? Math.min((t - this.last) / 1000, 0.1) : 0;
        this.last = t;
        var idle = !this.hovering && !this.dragging && performance.now() >= this.resumeAt;
        if (!this.reduceMotion && this.visible && idle && this.W) {
          this.pos = this.wrap(this.pos + this.direction * this.speed * dt);
          this.apply();
        }
        requestAnimationFrame((next) => this.tick(next));
      }
    }

    customElements.define('pd-marquee-row', PdMarqueeRow);
  })();

  } catch(e) { console.error(e); }
})();
})();
